/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tier } from '../../models/tier';

export interface GetLoyaltyProgramTier$Params {
  'Active-Tenant-Identifier': string;
  programId: string;
  tierId: string;
}

export function getLoyaltyProgramTier(http: HttpClient, rootUrl: string, params: GetLoyaltyProgramTier$Params, context?: HttpContext): Observable<StrictHttpResponse<Tier>> {
  const rb = new RequestBuilder(rootUrl, getLoyaltyProgramTier.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('programId', params.programId, {});
    rb.path('tierId', params.tierId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tier>;
    })
  );
}

getLoyaltyProgramTier.PATH = '/loyalty/programs/{programId}/tiers/{tierId}';
